module.exports = __webpack_public_path__ + "img/popup-entry-bg-1.10ad6e23.png";